<template>
	<page>
		<title-view>
			השאלות שלי
			<v-btn
				slot="actions"
				color="primary"
				@click="onEdit({})"
			>
				יצירת שאלה
			</v-btn>
		</title-view>
		<row>
			<c-col>
				<questions-table @edit="onEdit" />
			</c-col>
		</row>
		<popup-dialog
			v-model="openModal"
			:persistent="true"
		>
			<span slot="header">יצירת/עריכת שאלות</span>
			<question-form
				v-if="openModal"
				@save="openModal=false"
				@cancel="openModal=false"
			/>
		</popup-dialog>
	</page>
</template>

<script>
import QuestionForm from "./QuestionForm";
import QuestionsTable from "./QuestionsTable";
import { types } from "../../store/Question.module";

export default {
	name: "QuestionsView",
	components: { QuestionsTable, QuestionForm },
	data () {
		return {
			openModal: false,
		};
	},
	methods: {
		onEdit (question) {
			if (question.id) {
				this.$store.commit(types.GET, question);
			} else {
				this.$store.commit(types.CREATE, question);
			}
			this.openModal = true;
		},
	},

};
</script>

<style scoped>

</style>
